<template>
  <div id="hkWsVideo" class="hk-ws-video">
    <div :id="`player${HKIdx}`" class="playWnd" style="width: 100%; height: 100%"></div>
    <div id="player"></div>
  </div>
</template>
<script>
// import h5player from "../assets/h5player.min.js";
import { hex_md5 } from './../utils/md5'
var h5player = require('../assets/h5player.min.js');

export default {
  name: 'HKWebSocketVideo',
  props: {
    src: String
  },
  data() {
    return {
      HKIdx: '',
      HKvideoCode: '',
      initFlag: false,
      player: null
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    src: {
      async handler(nVal) {
        if (!nVal) {
          console.log('请提供海康src播放！')
          return
        }

        this.HKvideoCode = nVal
        // DOM ID 即使是同
        this.HKIdx = hex_md5(`${nVal}`)
        // 以Code为标准进行初始化Config
        this.initFlag = false
        // this.init();
        this.startPlay();
      },
      immediate: true
    }
  },
  methods: {
    init() {
      // 设置播放容器的宽高并监听窗口大小变化
      window.addEventListener('resize', () => {
        this.player && this.player.JS_Resize()
      })

      this.createPlayer();
    },
    createPlayer() {
      this.player = new h5player.JSPlugin({
        szId: 'player',
        szBasePath: './',
        iMaxSplit: 4,
        iCurrentSplit: 2,
        openDebug: true,
        oStyle: {
          borderSelect: '#FFCC00'
        }
      })
      this.player.JS_ArrangeWindow(1).then(
        () => { },
        e => { console.error(e) }
      )
      // 事件回调绑定
      this.player.JS_SetWindowControlCallback({
        windowEventSelect: function (iWndIndex) {
          //插件选中窗口回调
          console.log('windowSelect callback: ', iWndIndex)
        },
        pluginErrorHandler: function (iWndIndex, iErrorCode, oError) {
          //插件错误回调
          console.log('pluginError callback: ', iWndIndex, iErrorCode, oError)
        },
        windowEventOver: function (iWndIndex) {
          //鼠标移过回调
          //console.log(iWndIndex);
        },
        windowEventOut: function (iWndIndex) {
          //鼠标移出回调
          //console.log(iWndIndex);
        },
        windowEventUp: function (iWndIndex) {
          //鼠标mouseup事件回调
          //console.log(iWndIndex);
        },
        windowFullCcreenChange: function (bFull) {
          //全屏切换回调
          console.log('fullScreen callback: ', bFull)
        },
        firstFrameDisplay: function (iWndIndex, iWidth, iHeight) {
          //首帧显示回调
          console.log('firstFrame loaded callback: ', iWndIndex, iWidth, iHeight)
        },
        performanceLack: function () {
          //性能不足回调
          console.log('performanceLack callback: ')
        }
      })
    },
    startPlay() {
      // 
      const mode = 0; // 0 mse 1 wasm
      const index = this.player.currentWindowIndex;

      this.player.JS_Play(this.src, { playURL: this.src, mode: mode }, index).then(
        () => { console.log('realplay success') },
        e => { console.error(e) }
      )
    }
  }
}
</script>